// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .cell {\n  word-wrap: break-word !important;\n  word-break: normal !important;\n}\n", ""]);
// Exports
module.exports = exports;
